import { LightbulbCflIcon } from './LightbulbCflIcon';

/**
 * author: GreenTurtwig
 * id 7D6FF098-D459-4B89-A13C-C9145A1EB992
 * name lightbulb-cfl
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-cfl.svg
 * tags
 * - Home Automation 
 */
export const BulbCflIcon = LightbulbCflIcon;
export default BulbCflIcon